<stages-auto-complete-search
	#autoComplete
	[placeholder]="
		hasAssignableAndNonRestrictedDependentElementSubtype(dependentElementContainer) || this.sourceAssociation
			? targetElementCreateAllowed
				? ('process.element.quickAssign.select.dependentElementCreatePlaceholder' | translate)
				: ('process.element.quickAssign.select.dependentElementPlaceholder' | translate)
			: ('search.autoComplete.placeholder' | translate)
	"
	[query]="getSearchQuery()"
	(submitted)="selectItemCallback($event)"
	[searchResultTemplate]="searchResultTemplate"
	[searchResultSeparatorTemplate]="searchResultSeparatorTemplate"
	[createDependendElementAllowedCallback]="isCreateAllowed"
	[dropDownClass]="'margin-reduced-h'"
	[inputIconClasses]="getInputIconClasses()"
	[maxSearchTermLength]="255"
	(cancelled)="cancel()"
	(backButtonPressed)="back()"
	[isInSubordinatedElementsMode]="showSubordinatedElementsMode()"
	[backButtonActive]="backButtonActive"
>
	<ng-template #searchResultTemplate let-item>
		<i class="ico" [ngClass]="getIconClassesAndCheckForDependentType(item)"></i>
		<ng-container *ngIf="!item.isNew">
			<p *ngIf="!item.isNew" [ngClass]="getLabelClasses(item)" class="has-chevron-right">
				{{ item.label }}<i class="ico ico-change-workspace" *ngIf="item.isRemote"></i>
				<i
					class="ico ico-chevron-right ico-right"
					*ngIf="
						item.dependentElementsContainer &&
						(restrictAssociateDependentElementTypes === undefined || restrictAssociateDependentElementTypes!.length > 0)
					"
				></i>
			</p>
			<p class="workspace-name" *ngIf="item.isRemote">{{ item.workspaceName }}</p>
		</ng-container>
		<p
			*ngIf="item.isNew"
			[ngClass]="getLabelClasses(item)"
			[translate]="item.isComment ? 'search.autoComplete.createCommentOnlyAssociation' : 'search.autoComplete.create'"
			[translateParams]="{ ARG0: item.name }"
		></p>
	</ng-template>

	<ng-template #searchResultSeparatorTemplate let-item>
		<li class="separator" *ngIf="showSeparator(item)">
			<h6>
				<span
					[translate]="
						isItemInLocalWorkspace(item)
							? 'search.autoComplete.assocTarget.inThisWorkspace'
							: 'search.autoComplete.assocTarget.inOtherWorkspaces'
					"
				></span>
			</h6>
		</li>
	</ng-template>
</stages-auto-complete-search>
